import { h } from 'preact';
import { Route, Router } from 'preact-router';
import CssBaseline from '@mui/material/CssBaseline';
import { getURLSearchParams } from '../utils/getUrlParams';
import { ThemeProvider } from '@emotion/react';
import { signal } from '@preact/signals';
import getTheme from '../theme/themeSelector';
import Box from '@mui/material/Box';
import { lazy, Suspense } from 'preact/compat';

const Home = lazy(() => import('../routes/bookings'));
const Cancel = lazy(() => import('../routes/cancel'));
const Waitlist = lazy(() => import('../routes/waitlist'));
const KlarnaSuccess = lazy(() => import('../routes/klarnaSuccess'));
const Develop = lazy(() => import('../routes/develop'));

export const urlParams = signal(getURLSearchParams());
const paramTheme = urlParams.value['theme'] || 'dark';

const App = () => (
  <ThemeProvider theme={getTheme(paramTheme)}>
    <Box id='app'>
      <CssBaseline />
      <Suspense fallback={<div />}>
        <Box component={'main'} class='model1'>
          <Router>
            <Route path='/' component={Home} />
            <Route path='/cancel' component={Cancel} />
            <Route path='/waitlist' component={Waitlist} />
            <Route path='/klarna-success' component={KlarnaSuccess} />
            <Route path='/develop' component={Develop} />
          </Router>
        </Box>
      </Suspense>
    </Box>
  </ThemeProvider>
);

export default App;
